<div class="quill-wrapper">
  <div #quillEditor class="editor-host"></div>
</div>
